<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <app-breadcrumb-navigation
      [link]="LINK_CHAT"
      [dataTestId]="'messages-link'"
      [pageToNavigateTitle]="'PROFILE_NAVIGATION_MESSAGES'"
      [pageTitle]="'CHAT_BLOCKED_USER_TITLE'"
      [titleDataTestId]="'messages-blocked-users-title'"
    ></app-breadcrumb-navigation>
  </div>
  <div>
    <app-table-users-list
      [tableConstructorData]="tableData"
      [noUsersHint]="'CHAT_NO_BLOCKED_USER_TEXT'"
      (action)="unBlockUser($event)"
    ></app-table-users-list>
  </div>
  <div *ngIf="totalCount > PAGE_LIMIT" class="mt-1">
    <ngb-pagination
      class="w-100 d-flex justify-content-center"
      data-test-id="block-user-pagination-box"
      [collectionSize]="totalCount"
      [(page)]="currentPage"
      [maxSize]="3"
      [pageSize]="PAGE_LIMIT"
      [rotate]="true"
      (pageChange)="onPageChanged($event)"
    ></ngb-pagination>
  </div>
</div>
